<script>
export default {
  name: "app-back",
  methods: {
    back() {
      if (history.length > 1) {
        console.log(history.length);
        this.$router.back();
      } else {
        this.$router.push({ name: "finder" });
      }
    }
  }
};
</script>

<template>
  <a class="app-back" @click.prevent="back">
    <i class="sappfont sappfont-arrow-left is-size-4"></i>
  </a>
</template>

<style lang="scss">
@media only screen {
}
</style>
